import { ReactNode, MouseEventHandler, useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import './index.scss';

type TAnimationType =
    | 'fade_in' // 淡入
    | 'enter_from_the_left' // 从左侧进入
    | 'jitter_up_and_down' // 上下跳动
    | 'direct_display' // 直接显示
    | 'from_small_to_big' // 从小变大
    | undefined;

interface IProps {
    type?: TAnimationType;
    className?: string;
    style?: React.CSSProperties;
    children?: ReactNode;
    delay?: number;
    canExcuteAimation?: boolean;
    animationend?: () => void;
    onClick?: MouseEventHandler<HTMLDivElement>;
}

const AnimationContainer = ({ type, children, className, style, delay, animationend, onClick, canExcuteAimation }: IProps) => {
    const [animationType, setAnimationType] = useState<TAnimationType>(() => {
        return canExcuteAimation ? undefined : 'direct_display';
    });
    const nodeRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!canExcuteAimation) return;
        delay ? setTimeout(() => setAnimationType(type), delay) : setAnimationType(type);
    }, [type]);

    useEffect(() => {
        if (!animationend) return;
        nodeRef.current?.addEventListener('animationend', animationend, { once: true });
        return () => {
            nodeRef.current?.removeEventListener('animationend', animationend);
        };
    }, []);

    return (
        <div className={classNames(className, animationType)} ref={nodeRef} onClick={onClick} style={style}>
            {animationType ? children : null}
        </div>
    );
};

export default AnimationContainer;
